/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const tabchange = () => {
		if($('.js-products-tabchange').length) {
			let tabs = $('.js-products-tabchange');
			tabs.on('click', function() {
				tabs.removeClass(a);
				$(this).addClass(a); 
				const index = tabs.index(this);
				$('.js-products-tabchange-content').removeClass(a).eq(index).addClass(a);
			})
		}
	};

	// <TOP・製品検索結果>条件を絞り込む
	const searchBlock = () => {
		let $searchBtn =  $('.js-products-searchBtn');
		let $searchBlock =  $('.js-products-searchBlock');
		$searchBtn.on('click', (e) => {
			$(e.currentTarget).toggleClass(a);
			$searchBlock.slideToggle();
		});
	};

	const productsSearch = () => {
		if($('.inc_products_search_full').length) {
			const categorySelect = $('.js-search-cetegory');
			const subcategorySelect = $('.js-search-subcetegory');
			const subcategoryBlock = $('.js-search-subcetegoryWrap');
			const tagBlock = $('.js-search-taggroup-block');
			const keywordInput = $('.js-search-keyword');
			const clear = $('.js-search-clear');
			const getJSONcategory = () => {
				return $.getJSON(`/ajax/products/category_pulldown_menu.json`);
			};
			const getJSONsubcategory = (_category) => {
				return $.getJSON(`/ajax/products/sub_category_pulldown_menu/${_category}.json`);
			};
			const inputEventOn = () => {
				categorySelect.css('pointer-events', 'auto');
				subcategorySelect.css('pointer-events', 'auto');
			};
			const inputEventOff = () => {
				categorySelect.css('pointer-events', 'none');
				subcategorySelect.css('pointer-events', 'none');
			};
			// パラメータチェック
			let urlParam = location.search.substring(1);
			let paramArray = [];
			if(urlParam) {
				let param = urlParam.split('&');
				for(let i = 0; i < param.length; i++) {
					let paramItem = param[i].split('=');
					paramArray[paramItem[0]] = paramItem[1];
				}
			}
			// console.log(paramArray,'paramArray');
			// チェックボックス描画
			let addHtml = '<div class="products-search-inner">';
			let headText = '';
			for(let i = 0; i < $('.rt_bn_product_tag').length; i++) {
				let checkInput = '';
				if(!($('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_code')).prop('checked'))) {
					checkInput = '<input type="checkbox" name="'+$('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_group_code')).text()+'" value="'+$('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_code')).val()+'" class="js-search-taggroup-check">';
				} else {
					checkInput = '<input type="checkbox" name="'+$('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_group_code')).text()+'" value="'+$('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_code')).val()+'" class="js-search-taggroup-check js-search-taggroup-check-checked">';
				}
				if(!(headText === $('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_group_name')).text())) {
					if(!i == 0) {
						addHtml += '</ul></div></div>';
					}
					headText = $('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_group_name')).text();
					addHtml += '<div class="products-search-block di_none js-search-taggroup-item js-'+$('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_group_code')).text()+'">'+
					'<div class="_head">'+headText+'</div>'+
					'<div class="_body">'+
					'<ul class="_list">'+
					'<li class="">'+
					'<label class="mod-input-checkbox">'+
					checkInput+
					'<span class="mod-input-checkbox-text"><svg><use xlink:href="/common/svg/sprite.svg#check"></use></svg><span class="">'+$('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_name')).text()+'</span></span>'+
					'</label>'+
					'</li>';
				} else {
					addHtml += '<li class="">'+
					'<label class="mod-input-checkbox">'+
					checkInput+
					'<span class="mod-input-checkbox-text"><svg><use xlink:href="/common/svg/sprite.svg#check"></use></svg><span class="">'+$('.rt_bn_product_tag').eq(i).find($('.rt_cf_pt_name')).text()+'</span></span>'+
					'</label>'+
					'</li>';
				}
			}
			addHtml += '</ul></div></div></div>';
			tagBlock.append(addHtml);
			$('.js-search-taggroup-check-checked').prop('checked', true);
			$('.js-search-hidden input').prop('checked', false);
			const tagItem = $('.js-search-taggroup-item');
			const tagCheck = $('.js-search-taggroup-check');
			// 初期表示描画
			if(paramArray.p_keyword) {
				// $('.js-products-searchBtn').addClass(a);
				// $('.js-products-searchBlock').css('display','block');
			}
			inputEventOff();
			getJSONcategory().then((data) => {
				// console.log(data.rt_bn_product_category_list,'category');
				for(let i = 0; i < data.rt_bn_product_category_list.length; i++) {
					if(paramArray.p_category) {
						if(paramArray.p_category === data.rt_bn_product_category_list[i].cf_pc_main_code) {
							// $('.js-products-searchBtn').addClass(a);
							// $('.js-products-searchBlock').css('display','block');
							categorySelect.append($('<option>').html(data.rt_bn_product_category_list[i].cf_pc_main_name).val(data.rt_bn_product_category_list[i].cf_pc_main_code).prop('selected', true));
							getJSONsubcategory(data.rt_bn_product_category_list[i].cf_pc_main_code).then((data2) => {
								for(let i = 0; i < data2.rt_bn_product_category_list.length; i++) {
									let tagGrop = '';
									for(let l = 0; l < data2.rt_bn_product_category_list[i].cf_pc_tag_group.length; l++) {
										tagGrop += data2.rt_bn_product_category_list[i].cf_pc_tag_group[l]+','
									}
									if(paramArray.p_sub_category) {
										if(paramArray.p_sub_category === data2.rt_bn_product_category_list[i]._key) {
											subcategorySelect.append($('<option data-tag-group="'+tagGrop+'">').html(data2.rt_bn_product_category_list[i].cf_pc_sub_name).val(data2.rt_bn_product_category_list[i]._key).prop('selected', true));
											let thisTags = $('.js-search-subcetegory option:selected').data('tag-group').slice( 0, -1).split(',');
											for(let i = 0; i < thisTags.length; i++) {
												let thisLi = '.js-'+thisTags[i];
												$(thisLi).removeClass('di_none');
											}
											tagBlock.removeClass('di_none');
										} else {
											subcategorySelect.append($('<option data-tag-group="'+tagGrop+'">').html(data2.rt_bn_product_category_list[i].cf_pc_sub_name).val(data2.rt_bn_product_category_list[i]._key));
										}
									} else {
										subcategorySelect.append($('<option data-tag-group="'+tagGrop+'">').html(data2.rt_bn_product_category_list[i].cf_pc_sub_name).val(data2.rt_bn_product_category_list[i]._key));
									}
								}
								inputEventOn();
								subcategoryBlock.removeClass('di_none');
							});
						} else {
							categorySelect.append($('<option>').html(data.rt_bn_product_category_list[i].cf_pc_main_name).val(data.rt_bn_product_category_list[i].cf_pc_main_code));
							inputEventOn();
						}
					} else {
						// /products/category/$カテゴリ$/ページで第三ディレクトリのvalをセレクト
						if($('.products-category').length) {
							if(location.pathname.split('/')[3] === data.rt_bn_product_category_list[i].cf_pc_main_code) {
								console.log(data,'data');
								categorySelect.append($('<option>').html(data.rt_bn_product_category_list[i].cf_pc_main_name).val(data.rt_bn_product_category_list[i].cf_pc_main_code).prop('selected', true));
								getJSONsubcategory(data.rt_bn_product_category_list[i].cf_pc_main_code).then((data2) => {
									for(let i = 0; i < data2.rt_bn_product_category_list.length; i++) {
										let tagGrop = '';
										for(let l = 0; l < data2.rt_bn_product_category_list[i].cf_pc_tag_group.length; l++) {
											tagGrop += data2.rt_bn_product_category_list[i].cf_pc_tag_group[l]+','
										}
										subcategorySelect.append($('<option data-tag-group="'+tagGrop+'">').html(data2.rt_bn_product_category_list[i].cf_pc_sub_name).val(data2.rt_bn_product_category_list[i]._key));
									}
									inputEventOn();
									subcategoryBlock.removeClass('di_none');
								});
							} else {
								categorySelect.append($('<option>').html(data.rt_bn_product_category_list[i].cf_pc_main_name).val(data.rt_bn_product_category_list[i].cf_pc_main_code));
								inputEventOn();
							}
						} else {
							categorySelect.append($('<option>').html(data.rt_bn_product_category_list[i].cf_pc_main_name).val(data.rt_bn_product_category_list[i].cf_pc_main_code));
							inputEventOn();
						}
					}
				}
			});
			// サブカテゴリー描画
			categorySelect.change(function(){
				inputEventOff();
				subcategorySelect.find('option').remove();
				tagItem.addClass('di_none');
				tagCheck.prop('checked', false);
				tagBlock.addClass('di_none');
				if($(this).val()) {
					subcategorySelect.append($('<option class="di_none">').html('選択してください').val(''));
					getJSONsubcategory($(this).val()).then((data) => {
						// console.log(data,'subcategory');
						for(let i = 0; i < data.rt_bn_product_category_list.length; i++) {
							let tagGrop = '';
							for(let l = 0; l < data.rt_bn_product_category_list[i].cf_pc_tag_group.length; l++) {
								tagGrop += data.rt_bn_product_category_list[i].cf_pc_tag_group[l]+','
							}
							subcategorySelect.append($('<option data-tag-group="'+tagGrop+'">').html(data.rt_bn_product_category_list[i].cf_pc_sub_name).val(data.rt_bn_product_category_list[i]._key));
						}
						inputEventOn();
						subcategoryBlock.removeClass('di_none');
					});
				} else {
					inputEventOn();
					subcategoryBlock.addClass('di_none');
				}
				
			});
			// タグ描画
			subcategorySelect.change(function(){
				if($(this).val()) {
					tagItem.addClass('di_none');
					tagCheck.prop('checked', false);
					let thisTags = "";
					thisTags = $('.js-search-subcetegory option:selected').data('tag-group').slice( 0, -1).split(',');
					for(let i = 0; i < thisTags.length; i++) {
						let thisLi = '.js-'+thisTags[i];
						console.log($(thisLi),thisLi);
						$(thisLi).removeClass('di_none');
					}
					tagBlock.removeClass('di_none');
				} else {
					tagItem.addClass('di_none');
					tagCheck.prop('checked', false);
					tagBlock.addClass('di_none');
				}
			});
			// クリアボタン
			clear.on('click', function(){
				categorySelect.val('');
				subcategorySelect.val('');
				keywordInput.val('');
				subcategoryBlock.addClass('di_none');
				tagItem.addClass('di_none');
				tagCheck.prop('checked', false);
				tagBlock.addClass('di_none');
			});
			// キーワード
			if(paramArray.p_keyword) {
				// keywordInput.val(decodeURI(paramArray.p_keyword.replaceAll("+", " ")));
			}
			// サブミット
			$('.js-search-submit').on('click', function(){
				let searchinputVal = $(this).parents('.inc_products_search_full').find('.js-search-keyword').val().replaceAll(/[\"]/g,"").replaceAll(/[\']/g,"");
				let kewords = searchinputVal.normalize("NFKC").split(/\s/);
				let kewordVal = searchinputVal.normalize("NFKC");
				$(this).parents('.inc_products_search_full').find('.js-search-keyword').val(kewordVal);
				let keywordInputs;
				for(let i = 0; i < kewords.length; i++) {
					if(i == 0) {
						keywordInputs = '<input name="p_keyword_1" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 1) {
						keywordInputs = '<input name="p_keyword_2" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 2) {
						keywordInputs = '<input name="p_keyword_3" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 3) {
						keywordInputs = '<input name="p_keyword_4" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 4) {
						keywordInputs = '<input name="p_keyword_5" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 5) {
						keywordInputs = '<input name="p_keyword_6" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 6) {
						keywordInputs = '<input name="p_keyword_7" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 7) {
						keywordInputs = '<input name="p_keyword_8" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 8) {
						keywordInputs = '<input name="p_keyword_9" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					} else if(i == 9) {
						keywordInputs = '<input name="p_keyword_10" type="hidden" value="'+kewords[i]+'" />';
						 $(this).parents('form').append(keywordInputs);
					}
				}
				$(this).parents('form').submit();
			});
			$('.js-search-keyword').keypress(function(e){
				if(e.keyCode == 13) {
					let searchinputVal = $(this).parents('.inc_products_search_full').find('.js-search-keyword').val().replaceAll(/[\"]/g,"").replaceAll(/[\']/g,"");
					let kewords = searchinputVal.normalize("NFKC").split(/\s/);
					let kewordVal = searchinputVal.normalize("NFKC");
					$(this).parents('.inc_products_search_full').find('.js-search-keyword').val(kewordVal);
					let keywordInputs;
					for(let i = 0; i < kewords.length; i++) {
						if(i == 0) {
							keywordInputs = '<input name="p_keyword_1" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 1) {
							keywordInputs = '<input name="p_keyword_2" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 2) {
							keywordInputs = '<input name="p_keyword_3" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 3) {
							keywordInputs = '<input name="p_keyword_4" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 4) {
							keywordInputs = '<input name="p_keyword_5" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 5) {
							keywordInputs = '<input name="p_keyword_6" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 6) {
							keywordInputs = '<input name="p_keyword_7" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 7) {
							keywordInputs = '<input name="p_keyword_8" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 8) {
							keywordInputs = '<input name="p_keyword_9" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						} else if(i == 9) {
							keywordInputs = '<input name="p_keyword_10" type="hidden" value="'+kewords[i]+'" />';
							$(this).parents('form').append(keywordInputs);
						}
					}
					$(this).parents('form').submit();
					return false;
				}
			});
		}
	};

	const productsDetail = () => {
		if($('.products-detail').length) {
			var $slider = $('.products-detail-slider'),
				$slider_nav = $('.products-detail-slider-nav');
			// ナビゲーション用に複製
			$slider_nav.append($slider.contents().clone());
			$slider.slick({
				arrows: false,
				asNavFor: $slider_nav,
				fade: true,
				waitForAnimate: false,
				autoplay: false,
				infinite: true,
				dots: true,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				responsive: [{
					breakpoint: 768,
					settings: {
						infinite: true,
					}
				}]
			});
			$slider_nav.slick({
				arrows: false,
				slidesToShow: 3,
				asNavFor: $slider,
				focusOnSelect: true,
				infinite: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						infinite: true,
						slidesToShow: 4,
						swipeToSlide: true,
						speed: 0,
					}
				}]
			});
			$('.products-detail-color-slider').slick({
				arrows: false,
				slidesToShow: 4,
				focusOnSelect: true,
				infinite: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						infinite: true,
						slidesToShow: 4,
						slidesToScroll: 4,
						centerMode: true,
						centerPadding: '5%',
						swipeToSlide: true,
						cssEase: 'linear',
					}
				}]
			});
			if(!$('.products-detail-color-slider .slick-slide').length) {
				$('.products-detail-color-slider').parents('.products-detail-color-sliderWrap').addClass('di_none');
				$('.products-detail-color-slider').parents('.products-detail-color-sliderWrap').prev('h3').addClass('di_none');
			}
			if(!($('.products-detail-slider-nav .slick-slide').length > 4)) {
				$slider_nav.addClass(a);
			}
			if(!($(window).width() < 768)) {
				$slider_nav.addClass(a);
				$('.products-detail-color-slider').addClass(a);
			} else {
				$('.products-detail-color-slider').slick('unslick');
			}
		}
		$('.js-float-btn').on('click', function(){
			$('.js-float-btn').toggleClass(a);
			$('.js-float-Block').stop().slideToggle(400);
		});
		var timeoutId;
		$(window).scroll(function(e){
			$('.inc_products_detail_float').removeClass(a);
			clearTimeout(timeoutId);
			timeoutId = setTimeout( function () {
				$('.inc_products_detail_float').addClass(a);
			}, 1500 );
		});
		if($('.inc_products_lineup').length) {
			const getJSONLineup = (_brand,_category,_id) => {
				return $.getJSON(`/ajax/products/detail/${_brand}/${_category}/${_id}/lineup.json`);
			};
			getJSONLineup($('.rt_brand_code').eq(0).text(),$('.rt_sub_category_code').eq(0).text(),($('.rt_p_product_id').eq(0).text())).then((data) => {
				console.log(data,'lineupData');
				let Html = '';
				for(let l=0; l < data.rt_bn_product_info_lineup.length; l++) {
					if(data.rt_bn_product_info_lineup[l].rt_bn_product_info_lineup_total < 5) {
						$('.js-lineup-all-btn').addClass('di_none');
					}
					let brand = '';
					if(!data.rt_bn_product_info_lineup[l].rt_cf_p_brand) {
						brand = '';
					} else {
						brand = '<p class="color_gray2 mt10">'+data.rt_bn_product_info_lineup[l].rt_cf_p_brand.content[0]+'</p>';
					}
					if(l == 0) {
						if(!data.rt_bn_product_info_lineup[l].rt_cf_p_brand) {
							$('.js-lineup-all-btn').attr('href','/products/search/?p_category='+$('.rt_category_code').eq(0).text()+'&p_sub_category='+$('.rt_sub_category_code').eq(0).text()+'');
						} else {
							$('.js-lineup-all-btn').attr('href','/products/search/?p_keyword='+data.rt_bn_product_info_lineup[l].rt_cf_p_brand.content[0]+'&p_keyword_1='+data.rt_bn_product_info_lineup[l].rt_cf_p_brand.content[0]+'&p_category='+$('.rt_category_code').eq(0).text()+'&p_sub_category='+$('.rt_sub_category_code').eq(0).text()+'');
						}
					}
					let newIcon = '';
					let limitedIcon = '';
					let discontinuedIcon = '';
					if(!(data.rt_bn_product_info_lineup[l].rt_cf_p_icon_new === null)) {
						newIcon = '<span class="_icons-icon _icons-icon-new"><span>NEW</span></span>';
					}
					if(!(data.rt_bn_product_info_lineup[l].rt_cf_p_limited === null)) {
						limitedIcon = '<span class="_icons-icon _icons-icon-limited"><span>限定品</span></span>';
					}
					if(!(data.rt_bn_product_info_lineup[l].rt_cf_p_discon_date === null)) {
						discontinuedIcon = '<span class="_icons-icon _icons-icon-discontinued"><span>製造終了品</span></span>';
					}
					Html += '<li class="pure-u-1-4 pure-u-md-1-2 space-u-30-child">'+
					'<div class="mod-box01">'+
					'<button type="button" class="_link mod-link-zoom js-fav-btn-lineup js-fav-btn_absolute" data-id="'+data.rt_bn_product_info_lineup[l].rt_product_id_fav+'">'+
					'<span class="js-fav">'+
					'<svg class="mod-svg _off"><use xlink:href="/common/svg/sprite.svg#fav2" /></svg>'+
					'<svg class="mod-svg _on"><use xlink:href="/common/svg/sprite.svg#fav" /></svg>'+
					'</span>'+
					'</button>'+
					'<a href="'+data.rt_bn_product_info_lineup[l].rt_cf_p_href.href+'" class="_link">'+
					'<figure class="pos_relative mod-border _productsItem">'+
					'<span class="_icons">'+
					newIcon+
					limitedIcon+
					discontinuedIcon+
					'</span>'+
					'<img src="'+data.rt_bn_product_info_lineup[l].rt_cf_p_main_image.src+'" class="width-u-100" alt="'+data.rt_bn_product_info_lineup[l].rt_cf_p_name.content+'">'+
					'</figure>'+
					brand+
					'<p class="_title">'+data.rt_bn_product_info_lineup[l].rt_cf_p_name.content+'</p>'+
					'<p class="mt5 js-price_lineup">'+data.rt_bn_product_info_lineup[l].rt_cf_p_price.content+'</p>'+
					'</a>'+
					'</div>'+
					'</li>';
				}
				$('.inc_products_lineup ul').append(Html);
				// 描画後の値段設定
				if ($('.js-price_lineup').length) {
					for(var i = 0; i < $('.js-price_lineup').length; i++) {
						let price = $('.js-price_lineup').eq(i).text().replace(/\\/g,'');
						let pricestring = Number(price).toLocaleString();
						$('.js-price_lineup').eq(i).text(pricestring+'（税込）');
						$('.js-price_lineup').eq(i).prepend('&#xFFE5;');
					}
				}
				if(!data.rt_bn_product_info_lineup.length) {
					$('.inc_products_lineup').addClass('di_none');
				}
				const favBtn = $('.js-fav-btn-lineup');
				let prodCode;
				// すでにお気に入り追加されているitemをアクティブに
				for(let i=0; i < $('.js-fav-btn-lineup').length; i++) {
					prodCode = $('.js-fav-btn-lineup').eq(i).data('id');
					if(localStorage.getItem('favItem-' + prodCode)) {
						$('.js-fav-btn-lineup').eq(i).addClass(a);
					}
				}
				// お気に入り追加・削除
				$(document).on('click', '.js-fav-btn-lineup', function(){
					prodCode = $(this).data('id');
					// console.log(prodCode);
					let favoStorageLength = 0;
					for(let i in localStorage) {
						if(i.indexOf('favItem-') !== -1) {
							favoStorageLength ++;
						}
					}
					if(favoStorageLength < 40) {
						if(!$(this).hasClass(a)) {
							$(this).addClass(a);
							let favoDatetime = new Date();
							localStorage.setItem('favItem-' + prodCode, favoDatetime);
							prodCode = $(this).data('id');
							for(let i=0; i < favBtn.length; i++) {
								if(favBtn.eq(i).data('id') === prodCode){
									favBtn.eq(i).addClass(a);
								}
							}
						} else {
							$(this).removeClass(a);
							localStorage.removeItem('favItem-' + prodCode);
							prodCode = $(this).data('id');
							for(let i=0; i < favBtn.length; i++) {
								if(favBtn.eq(i).data('id') === prodCode){
									favBtn.eq(i).removeClass(a);
								}
							}
						}
					} else {
						if(!$(this).hasClass(a)) {
							alert('お気に入りの製品の登録は40件までです。お手数をお掛けしますが製品の削除をお願いいたします。');
						} else {
							$(this).removeClass(a);
							localStorage.removeItem('favItem-' + prodCode);
							prodCode = $(this).data('id');
							for(let i=0; i < favBtn.length; i++) {
								if(favBtn.eq(i).data('id') === prodCode){
									favBtn.eq(i).removeClass(a);
								}
							}
						}
					}
				});
			});
		}
		if($('.inc_products_recommend').length) {
			const getJSONRecommend = (_brand,_category) => {
				return $.getJSON(`/ajax/products/detail/${_brand}/${_category}/recommend.json`);
			};
			getJSONRecommend($('.rt_brand_code').eq(0).text(),($('.rt_sub_category_code').eq(0).text())).then((data) => {
				console.log(data,'recommend');
				let Html = '';
				for(let l=0; l < data.rt_bn_product_info_recommend.length; l++) {
					let brand = '';
					if(!data.rt_bn_product_info_recommend[l].rt_cf_p_brand) {
						brand = '';
					} else {
						brand = '<p class="color_gray2 mt10">'+data.rt_bn_product_info_recommend[l].rt_cf_p_brand.content[0]+'</p>';
					}
					let newIcon = '';
					let limitedIcon = '';
					let discontinuedIcon = '';
					if(!(data.rt_bn_product_info_recommend[l].rt_cf_p_icon_new === null)) {
						newIcon = '<span class="_icons-icon _icons-icon-new"><span>NEW</span></span>';
					}
					if(!(data.rt_bn_product_info_recommend[l].rt_cf_p_limited === null)) {
						limitedIcon = '<span class="_icons-icon _icons-icon-limited"><span>限定品</span></span>';
					}
					if(!(data.rt_bn_product_info_recommend[l].rt_cf_p_discon_date === null)) {
						discontinuedIcon = '<span class="_icons-icon _icons-icon-discontinued"><span>製造終了品</span></span>';
					}
					Html += '<div>'+
					'<div class="mod-box01">'+
					'<button type="button" class="_link mod-link-zoom js-fav-btn-recommend js-fav-btn_absolute" data-id="'+data.rt_bn_product_info_recommend[l].rt_product_id_fav+'">'+
					'<span class="js-fav">'+
					'<svg class="mod-svg _off"><use xlink:href="/common/svg/sprite.svg#fav2" /></svg>'+
					'<svg class="mod-svg _on"><use xlink:href="/common/svg/sprite.svg#fav" /></svg>'+
					'</span>'+
					'</button>'+
					'<a href="'+data.rt_bn_product_info_recommend[l].rt_cf_p_href.href+'" class="_link">'+
					'<figure class="pos_relative mod-border _productsItem">'+
					'<span class="_icons">'+
					newIcon+
					limitedIcon+
					discontinuedIcon+
					'</span>'+
					'<img src="'+data.rt_bn_product_info_recommend[l].rt_cf_p_main_image.src+'" class="width-u-100" alt="'+data.rt_bn_product_info_recommend[l].rt_cf_p_name.content+'">'+
					'</figure>'+
					brand+
					'<p class="_title">'+data.rt_bn_product_info_recommend[l].rt_cf_p_name.content+'</p>'+
					'<p class="mt5 js-price_recommend">'+data.rt_bn_product_info_recommend[l].rt_cf_p_price.content+'</p>'+
					'</a>'+
					'</div>'+
					'</div>';
				}
				$('.mod-slide-recommend').append(Html);
				// 描画後の値段設定
				if ($('.js-price_recommend').length) {
					for(var i = 0; i < $('.js-price_recommend').length; i++) {
						let price = $('.js-price_recommend').eq(i).text().replace(/\\/g,'');
						let pricestring = Number(price).toLocaleString();
						$('.js-price_recommend').eq(i).text(pricestring+'（税込）');
						$('.js-price_recommend').eq(i).prepend('&#xFFE5;');
					}
				}
				$('.mod-slide-recommend').slick({
					autoplay: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<a class="slick-prev" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					dots: false,
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
						}
					}]
				});
				if(!data.rt_bn_product_info_recommend.length) {
					$('.inc_products_recommend').addClass('di_none');
					$('.inc_products_support').addClass('mt100');
				}
				const favBtn = $('.js-fav-btn-recommend');
				let prodCode;
				// すでにお気に入り追加されているitemをアクティブに
				for(let i=0; i < $('.js-fav-btn-recommend').length; i++) {
					prodCode = $('.js-fav-btn-recommend').eq(i).data('id');
					if(localStorage.getItem('favItem-' + prodCode)) {
						$('.js-fav-btn-recommend').eq(i).addClass(a);
					}
				}
				// お気に入り追加・削除
				$(document).on('click', '.js-fav-btn-recommend', function(){
					prodCode = $(this).data('id');
					// console.log(prodCode);
					let favoStorageLength = 0;
					for(let i in localStorage) {
						if(i.indexOf('favItem-') !== -1) {
							favoStorageLength ++;
						}
					}
					if(favoStorageLength < 40) {
						if(!$(this).hasClass(a)) {
							$(this).addClass(a);
							let favoDatetime = new Date();
							localStorage.setItem('favItem-' + prodCode, favoDatetime);
							prodCode = $(this).data('id');
							for(let i=0; i < favBtn.length; i++) {
								if(favBtn.eq(i).data('id') === prodCode){
									favBtn.eq(i).addClass(a);
								}
							}
						} else {
							$(this).removeClass(a);
							localStorage.removeItem('favItem-' + prodCode);
							prodCode = $(this).data('id');
							for(let i=0; i < favBtn.length; i++) {
								if(favBtn.eq(i).data('id') === prodCode){
									favBtn.eq(i).removeClass(a);
								}
							}
						}
					} else {
						if(!$(this).hasClass(a)) {
							alert('お気に入り製品は40件以上登録できません。');
						} else {
							$(this).removeClass(a);
							localStorage.removeItem('favItem-' + prodCode);
							prodCode = $(this).data('id');
							for(let i=0; i < favBtn.length; i++) {
								if(favBtn.eq(i).data('id') === prodCode){
									favBtn.eq(i).removeClass(a);
								}
							}
						}
					}
				});
			});
		}
	};

	const productsBrand = () => {
		if($('.js-brand-item').length) {
			const getJSONbrandScene = (_id) => {
				return $.getJSON(`/ajax/products/${_id}/scene.json`);
			};
			for(let i=0; i < $('.js-brand-item').length; i++) {
				getJSONbrandScene($('.js-brand-item').eq(i).data('brand-code')).then((data) => {
					console.log(data);
					let Html = '<span class="_icons _brand">';
					for(let l=0; l < data.rt_bn_scene_list.length; l++) {
						Html += '<span class="_icons-icon"><span>'+data.rt_bn_scene_list[l].cf_ps_name+'</span></span>';
					}
					Html += '</span>';
					$('.js-brand-item').eq(i).find('.js-brand-icons').append(Html);
				});
			}
		}
		if($('.products-brand-list').length) {
			if($('.rt_bn_brand_list').length < 7) {
				$('.products-brand-list-btn').addClass('di_none');
			}
			$('.products-brand-list-btn').click(function() {
				$(this).addClass('di_none');
				$('.products-brand-list').addClass(a);
			});
		}
		$('.pure-u-md-1-2').each((idx, val) => {
			if (!$(val).text().replace(/(^\s+)|(\s+$)/g, "").length) {
				$(val).remove();
			}
		});
	};

	// お気に入りボタン
	const favClick = () => {
		const favBtn = $('.js-fav-btn');
		let prodCode, i;
		// すでにお気に入り追加されているitemをアクティブに
		for(i=0; i < favBtn.length; i++) {
			prodCode = favBtn.eq(i).data('id');
			if(localStorage.getItem('favItem-' + prodCode)) {
				favBtn.eq(i).addClass(a);
			}
		}
		// お気に入り追加・削除
		favBtn.on('click', function(){
			prodCode = $(this).data('id');
			let favoStorageLength = 0;
			for(let i in localStorage) {
				if(i.indexOf('favItem-') !== -1) {
					favoStorageLength ++;
				}
			}
			if(favoStorageLength < 40) {
				if(!$(this).hasClass(a)) {
					$(this).addClass(a);
					let favoDatetime = new Date();
					localStorage.setItem('favItem-' + prodCode, favoDatetime);
					prodCode = $(this).data('id');
					for(i=0; i < favBtn.length; i++) {
						if(favBtn.eq(i).data('id') === prodCode){
							favBtn.eq(i).addClass(a);
						}
					}
				} else {
					$(this).removeClass(a);
					localStorage.removeItem('favItem-' + prodCode);
					prodCode = $(this).data('id');
					for(i=0; i < favBtn.length; i++) {
						if(favBtn.eq(i).data('id') === prodCode){
							favBtn.eq(i).removeClass(a);
						}
					}
				}
			} else {
				if(!$(this).hasClass(a)) {
					alert('お気に入りの製品の登録は40件までです。お手数をお掛けしますが製品の削除をお願いいたします。');
				} else {
					$(this).removeClass(a);
					localStorage.removeItem('favItem-' + prodCode);
					prodCode = $(this).data('id');
					for(i=0; i < favBtn.length; i++) {
						if(favBtn.eq(i).data('id') === prodCode){
							favBtn.eq(i).removeClass(a);
						}
					}
				}
			}
		});
	};
	// お気に入りリスト描画
	const addFavList = () => {
		if($('.products-favorite-list').length) {
			const getJSONfavorite = (_id) => {
				return $.getJSON(`/ajax/products/favorite/${_id}.json`);
			};
			let addBlock = $('.products-favorite-list'), i, l;
			let favoStorage = [];
			let favArr = [];
			for(i in localStorage) {
				if(i.indexOf('favItem-') !== -1) {
					favoStorage.push(i);
				}
			}
			for(i = 0; i < favoStorage.length; i++) {
				let hash = {
					name: favoStorage[i],
					datetime: localStorage[favoStorage[i]]
				};
				favArr.push(hash);
			}
			if(!(favArr.length)) {
				$('.products-favorite-list-none').append(
					'<div class="opacity">'+
					'<a href="/products/search/" class="mod-button _300 _orange">'+
					'<span>製品検索<svg class="icon mod-iconRight"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg></span>'+
					'</a>'+
					'</div>');
				$('.js-remove-favlist').addClass('di_none');
				
			}
			// itemArray配列に、jsonの内容を格納
			let itemArray = [];
			let favItemList = new Promise((resolve) => {
				let items;
				let count = 0;
				for(i=0; i < favArr.length; i++) {
					getJSONfavorite(favArr[i].name.replace('favItem-', '')).then((data) => {
						console.log(data,'data1');
						if(!(data.rt_bn_product_list.length == 0)) {
							let brand = '';
							if(!data.rt_bn_product_list[0].rt_cf_p_brand) {
								brand = '';
							} else {
								brand = data.rt_bn_product_list[0].rt_cf_p_brand.content[0];
							}
							items = {
								rt_product_id_fav: data.rt_bn_product_list[0].rt_product_id_fav, // 製品ID
								rt_product_category_code_fav: data.rt_bn_product_list[0].rt_product_category_code_fav, // カテゴリコード
								rt_cf_p_icon_new: data.rt_bn_product_list[0].rt_cf_p_icon_new, // NEWアイコン※null以外でアイコン表示
								rt_cf_p_limited: data.rt_bn_product_list[0].rt_cf_p_limited, // 限定品アイコン※null以外でアイコン表示
								rt_cf_p_discon_date: data.rt_bn_product_list[0].rt_cf_p_discon_date, // 製造終了品アイコン※null以外でアイコン表示
								image_src: data.rt_bn_product_list[0].rt_cf_p_main_image.src, // 画像
								rt_cf_p_href: data.rt_bn_product_list[0].rt_cf_p_href.href, // 製品詳細リンク
								rt_cf_p_brand: brand, // ブランド名
								rt_cf_p_name: data.rt_bn_product_list[0].rt_cf_p_name.content, // 製品名
								rt_cf_p_price: data.rt_bn_product_list[0].rt_cf_p_price.content, // 価格
								// cf_pb_order: data.rt_bn_product_list[0].cf_p_brand.cf_pb_order, // ブランド並び順
								// cf_p_order: data.rt_bn_product_list[0].cf_p_order, // 製品並び順
								// cf_p_product_number: data.rt_bn_product_list[0].cf_p_product_number, // 製品並び順
							};
							itemArray.push(items);
							count ++;
							if(count === favArr.length) {
								return resolve(itemArray);
							}
						} else {
							// console.log(favArr[count].name,'no');
							localStorage.removeItem(favArr[count].name);
							location.href = '/products/favorite/';
						}
					});
				}
			});
			Promise.all([favItemList]).then(() => {
				// itemArray配列に時間を追加
				for(i=0; i < favArr.length; i++) {
					for(l=0; l < itemArray.length; l++) {
						if(favArr[i].name === ('favItem-'+itemArray[l].rt_product_id_fav)) {
							itemArray[l].datatime = favArr[i].datetime;
						}
					}
				}
				// 降順ソート
				itemArray.sort(function(sorta, sortb) {
					return (sorta.datatime < sortb.datatime ? 1 : -1);
				});
				// 描画
				// console.log(favArr.length,"favArr.length");
				for(i=0; i < favArr.length; i++) {
					let newIcon = '';
					let limitedIcon = '';
					let discontinuedIcon = '';
					if(!(itemArray[i].rt_cf_p_icon_new === null)) {
						newIcon = '<span class="_icons-icon _icons-icon-new"><span>NEW</span></span>';
					}
					if(!(itemArray[i].rt_cf_p_limited === null)) {
						limitedIcon = '<span class="_icons-icon _icons-icon-limited"><span>限定品</span></span>';
					}
					if(!(itemArray[i].rt_cf_p_discon_date === null)) {
						discontinuedIcon = '<span class="_icons-icon _icons-icon-discontinued"><span>製造終了品</span></span>';
					}
					addBlock.append('<li class="pure-u-1-4 pure-u-md-1-2 space-u-30-child">'+
					'<div class="products-favorite-list-item"><div class="mod-box01">'+
					'<button type="button" class="mod-link-zoom js-fav-btn-remove js-fav-btn_absolute" data-id="'+itemArray[i].rt_product_id_fav+'">'+
					'<span class="js-fav is-active">'+
					'<svg class="mod-svg _off"><use xlink:href="/common/svg/sprite.svg#fav2" /></svg>'+
					'<svg class="mod-svg _on"><use xlink:href="/common/svg/sprite.svg#fav" /></svg>'+
					'</span>'+
					'</button>'+
					'<a href="'+itemArray[i].rt_cf_p_href+'" class="_link mod-link-zoom">'+
					'<figure class="pos_relative mod-border _productsItem">'+
					'<span class="_icons">'+
					newIcon+
					limitedIcon+
					discontinuedIcon+
					'</span>'+
					'<img src="'+itemArray[i].image_src+'" class="width-u-100 _img" alt="'+itemArray[i].rt_cf_p_name+'">'+
					'</figure>'+
					'</a>'+
					'<div class="ta_center mt20 pt5 pb5 products-favorite-check">'+
					'<label class="mod-input-checkbox">'+
					'<input type="checkbox" name="fav_category" value="'+itemArray[i].rt_product_category_code_fav+'" class="js-fav-comparison">'+
					'<span class="mod-input-checkbox-text"><svg><use xlink:href="/common/svg/sprite.svg#check" /></svg>比較する</span>'+
					'</label>'+
					'</div>'+
					'<a href="'+itemArray[i].rt_cf_p_href+'" class="_link mod-link-zoom">'+
					'<p class="color_gray2 mt10 _brand">'+itemArray[i].rt_cf_p_brand+'</p>'+
					'<p class="_title">'+itemArray[i].rt_cf_p_name+'</p>'+
					'<p class="mt5 js-price">'+itemArray[i].rt_cf_p_price+'</p>'+
					'</a>'+
					'</div></div>'+
					'</li>');
				}
				// 描画後の値段設定
				if ($('.js-price').length) {
					for(var i = 0; i < $('.js-price').length; i++) {
						let price = $('.js-price').eq(i).text().replace(/\\/g,'');
						let pricestring = Number(price).toLocaleString();
						$('.js-price').eq(i).text(pricestring+'（税込）');
						$('.js-price').eq(i).prepend('&#xFFE5;');
					}
				}
			});
			// 20以上ならmoreボタン表示
			if(!(favArr.length < 21)) {
				$('.products-favorite-list-btn').removeClass('di_none');
			}
			// moreボタン
			$('.products-favorite-list-btn').on('click', () => {
				$('.products-favorite-list').addClass(a);
				$('.products-favorite-list-btn').addClass('di_none');
			});
			$(function(){
				// 比較するボタンのリンク設定関数
				const productsFavoriteFloatCompareBtn = () => {
					let link = '';
					for(i=0; i<$('input[name="fav_category"]:checked').length; i++) {
						if(i == 0) {
							link += '/products/compare/'+$('input[name="fav_category"]:checked').eq(i).val()+'/?p_product_id1='+$('input[name="fav_category"]:checked').eq(i).parents('.products-favorite-list-item').find('.js-fav-btn-remove').data('id');
						} else if(i == 1) {
							link += '&p_product_id2='+$('input[name="fav_category"]:checked').eq(i).parents('.products-favorite-list-item').find('.js-fav-btn-remove').data('id');
						} else if(i == 2) {
							link += '&p_product_id3='+$('input[name="fav_category"]:checked').eq(i).parents('.products-favorite-list-item').find('.js-fav-btn-remove').data('id');
						} else if(i == 3) {
							link += '&p_product_id4='+$('input[name="fav_category"]:checked').eq(i).parents('.products-favorite-list-item').find('.js-fav-btn-remove').data('id');
						} else if(i == 4) {
							link += '&p_product_id5='+$('input[name="fav_category"]:checked').eq(i).parents('.products-favorite-list-item').find('.js-fav-btn-remove').data('id');
						}
					}
					$('.products-favorite-float-compare').attr('href',link);
				};
				// スライダー描画用関数
				const productsFavoriteFloatCompareSlider = () => {
					// リセット
					if($('.products-favorite-float-slide').hasClass('slick-slider')) {
						$('.products-favorite-float-slide').slick('unslick');
					}
					$('.products-favorite-float-slide').html('');
					// sliderにアイテム追加
					for(i=0; i<$('input[name="fav_category"]').length; i++) {
						if($('input[name="fav_category"]').eq(i).prop('checked')) {
							$('.products-favorite-float-slide').append('<div class="products-favorite-float-slide-item">'+
							'<ul class="pure-g pure-g-align_center">'+
							'<li class="pure-u-1-4 ">'+
							'<figure class="ta_center"><img src="'+$('input[name="fav_category"]').eq(i).parents('.products-favorite-list-item').find('._img').attr('src')+'" class="製品dth-u-80" alt="'+$('input[name="fav_category"]').eq(i).parents('.products-favorite-list-item').find('._title').text()+'"></figure>'+
							'</li>'+
							'<li class="pure-u-3-4  ta_left">'+
							'<p class="color_gray2">'+$('input[name="fav_category"]').eq(i).parents('.products-favorite-list-item').find('._brand').text()+'</p>'+
							'<p class="mt10">'+$('input[name="fav_category"]').eq(i).parents('.products-favorite-list-item').find('._title').text()+'</p>'+
							'</li>'+
							'</ul>'+
							'<button type="button" class="_close products-favorite-float-slide-item-close" data-id="'+$('input[name="fav_category"]').eq(i).parents('.products-favorite-list-item').find('.js-fav-btn-remove').data('id')+'"><svg class="mod-svg"><use xlink:href="/common/svg/sprite.svg#close" /></svg></button>'+
							'</div>');
						}
					}
					if($('.products-favorite-float-slide-item').length == 1) {
						$('.products-favorite-float-slide').addClass('_item1');
					} else {
						$('.products-favorite-float-slide').removeClass('_item1');
					}
					if($('.products-favorite-float-slide-item').length) {
						if(!($(window).width() < 768)) {
							$('.products-favorite-float-slide').slick({
								autoplay: false,
								slidesToShow: 3,
								slidesToScroll: 1,
								loop: false,
								arrows: true,
								prevArrow: '<a class="slick-prev" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
								nextArrow: '<a class="slick-next" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
								dots: false,
								responsive: [{
									breakpoint: 768,
									settings: {
										arrows: false,
										swipe: true,
										centerMode: true,
										slidesToShow: 1,
									}
								}]
							});
						}
						// floatエリア表示
						$('.products-favorite-float').addClass(a);
					} else {
						// floatエリア非表示
						$('.products-favorite-float').removeClass(a);
						$('.products-favorite-list-item').removeClass('is-grayout');
					}
				};
				// 描画後の、お気に入り削除
				$(document).on('click', '.js-fav-btn-remove', function(){
					localStorage.removeItem('favItem-' + $(this).data('id'));
					location.href = '/products/favorite/';
					// $(this).parents('li').remove();
					// productsFavoriteFloatCompareSlider();
					// productsFavoriteFloatCompareBtn();
				});
				// 描画後の、比較するチェックイベント
				$(document).on('change', 'input[name="fav_category"]', function(){
					const favitem = $('.products-favorite-list-item');
					const compareInput = $('input[name="fav_category"]');
					// 比較する商品数設定
					$('.products-favorite-float_num').html($('input[name="fav_category"]:checked').length);
					if($(this).prop('checked')) {
						if(!($('input[name="fav_category"]:checked').length < 6)) {
							alert('一度に比較できる製品は5件までです。5件ずつ分けて比較くださいますようお願いいたします。');
							$(this).prop('checked', false);
							// 比較する商品数設定
							$('.products-favorite-float_num').html($('input[name="fav_category"]:checked').length);
						} else if(!($('input[name="fav_category"]:checked').length < 2)) {
							// 選択項目表示
							favitem.addClass('is-grayout');
							$(this).parents('.products-favorite-list-item').removeClass('is-grayout');
							for(i=0; i<compareInput.length; i++) {
								if(compareInput.eq(i).val() === $(this).val()) {
									compareInput.eq(i).parents('.products-favorite-list-item').removeClass('is-grayout');
								}
							}
							productsFavoriteFloatCompareSlider();
						} else {
							// 選択項目表示
							favitem.addClass('is-grayout');
							$(this).parents('.products-favorite-list-item').removeClass('is-grayout');
							for(i=0; i<compareInput.length; i++) {
								if(compareInput.eq(i).val() === $(this).val()) {
									compareInput.eq(i).parents('.products-favorite-list-item').removeClass('is-grayout');
								}
							}
							// floatエリア非表示
							$('.products-favorite-float').removeClass(a);
						}
					} else {
						if(!($('input[name="fav_category"]:checked').length < 2)) {
							productsFavoriteFloatCompareSlider();
						} else {
							productsFavoriteFloatCompareSlider();
							$('.products-favorite-float').removeClass(a);
						}
					}
					productsFavoriteFloatCompareBtn();
				});
				// 描画後の、比較する製品すべて削除
				$(document).on('click', '.products-favorite-float-remove', function(){
					// リセット
					if($('.products-favorite-float-slide').hasClass('slick-slider')) {
						$('.products-favorite-float-slide').slick('unslick');
					}
					$('.products-favorite-float-slide').html('');
					// floatエリア非表示
					$('.products-favorite-float').removeClass(a);
					$('.products-favorite-list-item').removeClass('is-grayout');
					$('input[name="fav_category"]').prop('checked', false);
					productsFavoriteFloatCompareBtn();
				});
				$(document).on('click', '.products-favorite-float-remove-icon', function(){
					// リセット
					if($('.products-favorite-float-slide').hasClass('slick-slider')) {
						$('.products-favorite-float-slide').slick('unslick');
					}
					$('.products-favorite-float-slide').html('');
					// floatエリア非表示
					$('.products-favorite-float').removeClass(a);
					$('.products-favorite-list-item').removeClass('is-grayout');
					$('input[name="fav_category"]').prop('checked', false);
					productsFavoriteFloatCompareBtn();
				});
				// 描画後の、比較する製品スライダー内の削除ボタン
				$(document).on('click', '.products-favorite-float-slide-item-close', function(){
					console.log($(this).data('id'));
					for(i=0; i<$('input[name="fav_category"]').length; i++) {
						if($('input[name="fav_category"]').eq(i).parents('.products-favorite-list-item').find('.js-fav-btn-remove').data('id') === $(this).data('id')) {
							$('input[name="fav_category"]').eq(i).prop('checked', false);
						}
					}
					$('.products-favorite-float_num').html($('input[name="fav_category"]:checked').length);
					productsFavoriteFloatCompareSlider();
					productsFavoriteFloatCompareBtn();
				});
			});
		}
	};
	// お気に入りリスト全削除ボタン
	const removeFavList = () => {
		$('.js-remove-favlist').on('click', function(){
			let favoStorage = [];
			let favArr = [];
			let i;
			for(i in localStorage) {
				if(i.indexOf('favItem-') !== -1) {
					favoStorage.push(i);
				}
			}
			for(i = 0; i < favoStorage.length; i++) {
				let hash = {
					name: favoStorage[i],
					datetime: localStorage[favoStorage[i]]
				};
				favArr.push(hash);
			}
			for(i=0; i < favArr.length; i++) {
				console.log(favArr[i].name);
				localStorage.removeItem(favArr[i].name);
			}
			location.reload();
		});
	};
	const productsPickup = () => {
		if($('.js-products-pickup').length) {
			const getJSONbrandName = () => {
				return $.getJSON(`/ajax/products/brand_name.json`);
			};
			getJSONbrandName().then((data) => {
				for(let l = 0; l < $('.js-products-pickup').length; l++) {
					for(let i = 0; i < data.rt_bn_product_pickup_brand_name.length; i++) {
						if($('.js-products-pickup').eq(l).find('.js-fav-btn').data('id') === data.rt_bn_product_pickup_brand_name[i]._key) {
							$('.js-products-pickup').eq(l).find('.color_gray2').text(data.rt_bn_product_pickup_brand_name[i].brand_name);
						}
					}
				}
			});
		}
	};

	tabchange();
	productsSearch();
	productsDetail();
	productsBrand();
	favClick();
	addFavList();
	removeFavList();
	productsPickup();
	
	if($('.js-products-searchBtn').length) {
		searchBlock();
	}

})(window.jQuery, window.FUNCTIONS);
$(window).on('load', function(){
	const a = 'is-active';
	$('.js-search-keyword').removeClass('is-hidden');
	$('.js-search-submit').removeClass('is-hidden');
	const compareTbl = () => {
		if($('.js-products_compare').length) {
			if(!$('.rt_bn_product_info1').length) {
				$('.js-products_compare').html('','');
				$('.js-products_compare').addClass('pl0');
				$('.js-products_compare').append(
					'<p class="ta_center">比較する製品を追加してください。</p><div class="opacity mod-spacer">'+
					'<a href="/products/search/" class="mod-button _300 _orange">'+
					'<span>比較する製品を追加<svg class="icon mod-iconRight"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg></span>'+
					'</a>'+
					'</div>');
			}
			$('.js-products_compare-remove').click(function() {
				$('.products-compare-tbl').css('height',$('.js-products_compare').height());
				$(this).parents('ul').remove();
				if($('.products-compare-tbl ul').length == 1) {
					$('.js-products_compare').html('','');
					$('.js-products_compare').addClass('pl0');
					$('.js-products_compare').append(
						'<p class="ta_center">比較する製品を追加してください。</p><div class="opacity mod-spacer">'+
						'<a href="/products/search/" class="mod-button _300 _orange">'+
						'<span>比較する製品を追加<svg class="icon mod-iconRight"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg></span>'+
						'</a>'+
						'</div>');
				}
			});
			$('.js-products_compare').addClass(a);
		}
	};
	compareTbl();
});